export default "__VITE_ASSET__D3o788qY__"